// Simple event emitter for XP updates
class XPEventEmitter extends EventTarget {
  emitXPAwarded() {
    this.dispatchEvent(new CustomEvent('xp-awarded'));
  }
  
  onXPAwarded(callback: () => void) {
    const handler = () => callback();
    this.addEventListener('xp-awarded', handler);
    return () => this.removeEventListener('xp-awarded', handler);
  }
}

export const xpEvents = new XPEventEmitter();